import { render } from "./ChurchKikirpa.vue?vue&type=template&id=3891870a&scoped=true"
import script from "./ChurchKikirpa.vue?vue&type=script&lang=js"
export * from "./ChurchKikirpa.vue?vue&type=script&lang=js"

import "./ChurchKikirpa.vue?vue&type=style&index=0&id=3891870a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3891870a"]])

export default __exports__